/**
 * Runtime config injected by /config.js before the app bundle loads. Falls back
 * to defaults when /config.js is absent — e.g. during local dev or before a
 * deployment-specific config.js has been created from the example.
 */
const appConfig: AppConfig =
  typeof window !== "undefined" && window.APP_CONFIG ? window.APP_CONFIG : {};

/** Used when config.js does not set BASE_URL. */
const DEFAULT_BASE_URL = "https://bergmann-roulette-test.aleacontrol.net";

/** Used when config.js does not set MIDDLEWARE_URL. */
const DEFAULT_MIDDLEWARE_URL =
  "https://demo.aleacontrol.net/AleaOnlineGamesTest/AleaOnline?";

/**
 * Base URL of the API server. A missing or empty value falls back to the test
 * backend, so a config.js that was never created cannot leave the panel calling
 * an empty host.
 */
export const BASE_URL = appConfig.BASE_URL || DEFAULT_BASE_URL;

/**
 * Sign-in endpoint of the AleaOnline middleware, called once on startup to get
 * the game endpoint and the token pair. Keeps its trailing "?" — the URL params
 * of the production flow are appended to it.
 */
export const MIDDLEWARE_URL = appConfig.MIDDLEWARE_URL || DEFAULT_MIDDLEWARE_URL;
